import React, { FC, useCallback, useContext, useState } from 'react';

import BasicButton from '../../../components/buttons/basicButton';
import AampeTooltip from '../../../components/shared/AampeTooltip/AampeTooltip';

import { FormulaType } from '../../../constants/formulaType';
import { ToastStatus } from '../../../constants/toastMessage.constants';

import { EditorContext } from '../../../context/EditorContext';

import useHandleQueryParams from '../../../hooks/helper/useHandleQueryParams';

import { toastService } from '../../../services/toast.service';

import TestFormulaModal from '../formulaEditor/assistant/testFormula/TestFormulaModal';

interface FormulaSendMessageActionProps {
    formulaId: string;
}

const FormulaSendTestMessageAction: FC<FormulaSendMessageActionProps> = () => {
    const [showTestMessageModal, setShowTestMessageModal] =
        useState<boolean>(false);
    const [, setQueryParams] = useHandleQueryParams();

    const {
        editorDetails: { formula },
    } = useContext(EditorContext);

    const handleShowTestMessageModal = useCallback(() => {
        const messageType = formula?.message_type;
        const fromField = formula?.additional_metadata?.from_;
        if (messageType === FormulaType.email && !fromField) {
            toastService.showNotificationToast(
                ToastStatus.Error,
                'From field is required',
            );
            setQueryParams({ current_step: 'setup' });
            return;
        }
        setShowTestMessageModal(true);
    }, [formula, setQueryParams]);

    return (
        <>
            <AampeTooltip title="Send test message" arrow>
                <span>
                    <BasicButton
                        name="Send a test message"
                        isPrimary={false}
                        action={handleShowTestMessageModal}
                    />
                </span>
            </AampeTooltip>
            {showTestMessageModal && (
                <TestFormulaModal
                    handleClose={() => setShowTestMessageModal(false)}
                />
            )}
        </>
    );
};
export default FormulaSendTestMessageAction;
